import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import CheckmarkSharp from "../../resources/icons/CheckmarkSharp.jsx";
import CheckmarkDoneSharp from "../../resources/icons/CheckmarkDoneSharp.jsx";
import CloudDownload from "../../resources/icons/CloudDownload.jsx";
import Trash from "../../resources/icons/Trash.jsx";
import Create from "../../resources/icons/Create.jsx";
import Bookmark from "../../resources/icons/Bookmark.jsx";
import Send from "../../resources/icons/Send.jsx";
import CheckmarkCircle from "../../resources/icons/CheckmarkCircle.jsx";
import CloseCircle from "../../resources/icons/CheckmarkCircle.jsx";
class ChatMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: null,
      mark: -1,
      is_pinned: false,
      edit: false,
      init_delete: false,
    };
    this.deleteMsg = this.deleteMsg.bind(this);
    this.editMsg = this.editMsg.bind(this);
    this.sendEditedMsg = this.sendEditedMsg.bind(this);
    this.setPin = this.setPin.bind(this);
    this.initDelete = this.initDelete.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.editRef = React.createRef();
  }
  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      msg: nextProps.msg,
      is_pinned: nextProps.msg.is_pinned,
      //init_delete: nextProps.msg.init_delete,
    };
  }
  getTimeFromTs(ts) {
    if (ts == 0) {
      return "";
    } else {
      let date =
        new Date(ts).getDate().toString().padStart(2, "0") +
        "." +
        (new Date(ts).getMonth() + 1).toString().padStart(2, "0") +
        "." +
        new Date(ts).getFullYear().toString();

      let date_now =
        new Date().getDate().toString().padStart(2, "0") +
        "." +
        (new Date().getMonth() + 1).toString().padStart(2, "0") +
        "." +
        new Date().getFullYear().toString();
      let time =
        new Date(ts).getHours().toString().padStart(2, "0") +
        ":" +
        new Date(ts).getMinutes().toString().padStart(2, "0") +
        ":" +
        new Date(ts).getSeconds().toString().padStart(2, "0");
      if (date == date_now) {
        return time;
      } else {
        return date + " " + time;
      }
    }
  }
  send_feedback(message_id, mark) {
    return (e) => {
      fetch(this.props.mentorChatApiRoot + "/bot/feedback", {
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("mentor_chat_token"),
          message_id: parseInt(message_id),
          mark: parseInt(mark),
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            this.setState({
              mark: parseInt(mark),
            });
          },
          (error) => {
            console.log(error);
          },
        );
    };
  }
  initDelete() {
    this.setState({ init_delete: true });
  }
  cancelDelete() {
    this.setState({ init_delete: false });
  }
  deleteMsg() {
    fetch(this.props.mentorChatApiRoot + "/message/delete", {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("mentor_chat_token"),
        message_id: parseInt(this.state.msg.message_id),
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.props.deleteMessage(this.state.msg.message_id);
        },
        (error) => {
          console.log(error);
        },
      );
  }
  editMsg() {
    console.log(this.state.msg);
    this.setState({ edit: !this.state.edit });
  }
  sendEditedMsg() {
    console.log(this.editRef.current.value);
    fetch(this.props.mentorChatApiRoot + "/message/edit", {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("mentor_chat_token"),
        message_id: parseInt(this.state.msg.message_id),
        text: this.editRef.current.value,
        attachments: this.state.msg.attachments,
        attached: this.state.msg.attachments?.length > 0,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.props.deleteMessage(this.state.msg.message_id);
        },
        (error) => {
          console.log(error);
        },
      );
  }
  setPin() {
    let pinned = !this.state.is_pinned;
    fetch(this.props.mentorChatApiRoot + "/message/pin", {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("mentor_chat_token"),
        message_id: parseInt(this.state.msg.message_id),
        is_pinned: pinned,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.props.pinMessage(this.state.msg.message_id, pinned);
        },
        (error) => {
          console.log(error);
        },
      );
  }
  getAttachments(msg) {
    if (Array.isArray(msg.attachments)) {
      return msg.attachments;
    }

    if (msg.uuid && msg.attachment_path) {
      return [
        {
          uuid: msg.uuid,
          file_name: msg.file_name,
          attachment_path: msg.attachment_path,
        },
      ];
    }

    return [];
  }
  render() {
    const { msg, mark, is_pinned, edit, init_delete } = this.state;

    const attachments = this.getAttachments(msg);
    return (
      <div
        className="MentorChatMessageContainer"
        style={{
          backgroundColor: msg.self ? "#f0f0f0" : "#ffffff",
        }}
      >
        <div
          className="MentorChatMessagePingContainer"
          style={{
            display:
              is_pinned && localStorage.getItem("user_type") === "tutor"
                ? "flex"
                : "none",
          }}
        >
          <Bookmark color="#ff0000" height="32px" width="32px" />
        </div>
        <div className="MentorChatMessageActionsContainer">
          <div
            className="MentorChatMessageActionBtn"
            style={{
              display:
                localStorage.getItem("user_type") === "tutor" ? "flex" : "none",
            }}
            title="Закладка"
            onClick={this.setPin}
          >
            <Bookmark color="#ff0000" height="24px" width="24px" />
          </div>
          <div
            className="MentorChatMessageActionBtn"
            style={{
              display: msg.self ? "flex" : "none",
            }}
            title="Изменить текст"
            onClick={this.editMsg}
          >
            <Create color="#707070" height="24px" width="24px" />
          </div>
          <div
            className="MentorChatMessageActionBtn"
            style={{
              display:
                msg.self &&
                !init_delete &&
                localStorage.getItem("user_type") === "tutor"
                  ? "flex"
                  : "none",
            }}
            title="Удалить"
            onClick={this.initDelete}
          >
            <Trash color="#aa0000" height="24px" width="24px" />
          </div>
          <div
            className="MentorChatMessageActionBtn"
            style={{
              display:
                msg.self &&
                init_delete &&
                localStorage.getItem("user_type") === "tutor"
                  ? "flex"
                  : "none",
            }}
            title="Удалить"
            onClick={this.deleteMsg}
          >
            <CheckmarkCircle color="#aa0000" height="24px" width="24px" />
          </div>
          <div
            className="MentorChatMessageActionBtn"
            style={{
              display:
                msg.self &&
                init_delete &&
                localStorage.getItem("user_type") === "tutor"
                  ? "flex"
                  : "none",
            }}
            title="Отмена"
            onClick={this.cancelDelete}
          >
            <CloseCircle color="#abcd45" height="24px" width="24px" />
          </div>
        </div>
        <div className="MentorChatMessageHeader">
          <div className="MentorChatMessageUserName">{msg.user_name}</div>
          <div className="MentorChatMessageTime">
            {this.getTimeFromTs(msg.ts * 1000)}
          </div>
        </div>
        <div className="MentorChatMessageText">
          <pre style={{ display: edit ? "none" : "block" }}>
            <ReactMarkdown>{msg.text}</ReactMarkdown>
          </pre>
          <textarea
            class="MentorChatEditMessage"
            style={{ display: edit ? "block" : "none" }}
            ref={this.editRef}
          >
            {msg.text}
          </textarea>
          <div
            style={{
              display: edit ? "flex" : "none",
              justifyContent: "flex-end",
              minWidth: "calc(100% - 24px)",
            }}
          >
            <div className="ChatSendMsgButton" onClick={this.sendEditedMsg}>
              <Send color="#3b7cbe" height="32px" width="32px" />
            </div>
          </div>
        </div>
        <div
          className="MentorChatMessageInfoContainer"
          style={{
            display:
              !msg.self &&
              attachments.length === 0 &&
              msg.feedback_mark !== "0" &&
              !msg.edited
                ? "none"
                : "block",
            flexDirection: "column",
          }}
        >
          <div className="MentorChatMessageAttachment">
            {attachments.map((attachment) => (
              <a
                key={attachment.uuid}
                title="Скачать"
                className="MentorChatAttachmentLink"
                href={attachment.attachment_path}
                download={attachment.file_name}
              >
                <CloudDownload color="#707070" height="25px" width="25px" />
                &nbsp;
                <span>{attachment.file_name}</span>
              </a>
            ))}
          </div>
          <div
            className="MentorChatMessageFeedback"
            style={{
              visibility:
                msg.feedback_mark === "0" && mark === -1 ? "visible" : "hidden",
            }}
          >
            {msg.feedback_mark === "0" ? (
              <>
                <b> Помог ли Вам мой ответ? </b>
                <div
                  className="MentorChatFeedbackButton"
                  onClick={this.send_feedback(msg.message_id, 5)}
                >
                  Да
                </div>
                <div
                  className="MentorChatFeedbackButton"
                  onClick={this.send_feedback(msg.message_id, 1)}
                >
                  Нет
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div
            className="MentorChatMessageStatus"
            style={{ display: msg.self ? "flex" : "none" }}
            title={
              msg.readed
                ? "Собеседник прочитал " + this.getTimeFromTs(msg.readed * 1000)
                : ""
            }
          >
            <span
              className="MentorChatMessageEdited"
              style={{
                display: msg.edited ? "inline-block" : "none",
              }}
            >
              {"Изменено " + this.getTimeFromTs(msg.edited * 1000)}
            </span>
            {msg.readed ? (
              <CheckmarkDoneSharp color="#abcd45" height="20px" width="20px" />
            ) : (
              <CheckmarkSharp color="#707070" height="20px" width="20px" />
            )}
          </div>
          <div
            className="MentorChatMessageStatus"
            style={{
              display: !msg.self && msg.edited ? "flex" : "none",
            }}
            title={
              "Собеседник изменил сообщение " +
              this.getTimeFromTs(msg.edited * 1000)
            }
          >
            <span className="MentorChatMessageEdited">
              {"Изменено " + this.getTimeFromTs(msg.edited * 1000)}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
export default ChatMessage;
